import { AppleSpinner } from './subcomponents/AppleSpinner';
import { Spinner } from './subcomponents/Spinner';

import { classNames } from '../utils/classNames';

function getOperatingSystem() {
	if (typeof window === 'undefined') return 'Apple';

	const userAgent = window.navigator.userAgent;
	if (userAgent.indexOf('Win') !== -1) return 'Windows';
	if (userAgent.indexOf('Android') !== -1) return 'Android';
	if (userAgent.indexOf('Linux') !== -1) return 'Linux';

	return 'Apple';
}

export type ActivityIndicatorProps = {
	className?: string;
	fullPage?: boolean;
};

export const ActivityIndicator = ({ className, fullPage }: ActivityIndicatorProps) => {
	const operatingSystem = getOperatingSystem();
	const isApple = operatingSystem === 'Apple';

	const spinnerClasses = classNames('animate-spin text-content-primary', className);

	return (
		<div
			aria-live="polite"
			role="status"
			data-testid="activity-indicator"
			className={classNames({
				'absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center': fullPage,
			})}>
			{isApple ? <AppleSpinner className={spinnerClasses} /> : <Spinner className={spinnerClasses} />}
		</div>
	);
};
